import { Playground } from 'docz';
import { Tag, Tags } from "../../../../../src/components/Elements";
import * as React from 'react';
export default {
  Playground,
  Tag,
  Tags,
  React
};